import { pushCheckoutStepInUrl } from '../checkoutUrlState'
import {
  checkoutAddressToForm,
  resolveNextStepFromSession,
  type CheckoutFlowAction,
  type CheckoutFlowState,
} from '../CheckoutFlow.types'

export const resolveSubmitSession = ({
  state,
  dispatch,
}: {
  state: CheckoutFlowState
  dispatch: (action: CheckoutFlowAction) => void
}): CheckoutFlowState['session'] => {
  if (state.session) return state.session
  dispatch({
    type: 'SET_ERROR',
    code: 'session_load_failed',
    detail: 'Sessione checkout non disponibile. Riprova.',
  })
  return null
}

export const applySessionUpdate = ({
  dispatch,
  state,
  session,
}: {
  dispatch: (action: CheckoutFlowAction) => void
  state: CheckoutFlowState
  session: NonNullable<CheckoutFlowState['session']>
}) => {
  dispatch({
    type: 'SESSION_UPDATED',
    session,
    shippingAddressForm: checkoutAddressToForm(session.shippingAddress),
    billingAddressForm: checkoutAddressToForm(session.billingAddress),
    selectedShippingMethod: session.shippingMethod?.code ?? state.selectedShippingMethod,
    selectedPaymentProvider: session.selectedPaymentProvider ?? state.selectedPaymentProvider,
    step: resolveNextStepFromSession(session),
  })
  pushCheckoutStepInUrl(resolveNextStepFromSession(session))
}
